import React from "react";
import {FiPlus} from "react-icons/fi";
import {FieldArray} from "react-final-form-arrays";
import DeviceTemplateCustomRuleAssignField from "./DeviceTemplateCustomRuleAssignField";
import {useTranslation} from "react-i18next";

const DeviceTemplateCustomRules = ({doPush,name}) => {

    const {t} = useTranslation()

    const addValue = () => {
        doPush(`${name}.customRule`, {})
    }

    const ButtonAdd = () => (
        <div className={"form-element"}>
            <button
                onClick={() => {
                    addValue();
                }}
                className={"btn btn-default btn-rounded btn-icon hover:bg-enigoo-600 bg-enigoo-500 text-white"}>
                {t("basics.add")} <FiPlus size={10} className={"ml-2"}/>
            </button>
        </div>
    )

    return (
        <>
            <div className="flex flex-col mt-1 mb-2 w-full lg:space-x-2 text-sm block w-full">
                <div className={"form-label"}>{t("deviceTemplate.customRules")}:</div>
                <ButtonAdd/>
            </div>
            <FieldArray name={`${name}.customRule`}>
                {({fields}) => {
                    return (
                        <div
                            className={`grid text-sm mt-5 lg:grid-cols-2 grid-cols-1 gap-2`}>
                            {fields.map((name, index) => (
                                <div key={name}>
                                    <DeviceTemplateCustomRuleAssignField fields={fields} name={name} index={index} doPush={doPush}/>
                                </div>
                            ))}
                        </div>
                    )
                }
                }
            </FieldArray>
        </>
    )

}
export default DeviceTemplateCustomRules;
